
(() => {
  const onReady = (callback) => {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback, { once: true });
    } else {
      callback();
    }
  };

  onReady(() => {
    const body = document.body;
    if (!body.classList.contains('template-product')) return;

    // Mobile navigation.
    const mobileMenu = document.querySelector('[data-imm-mobile-menu]');
    const openMenu = document.querySelector('[data-imm-menu-open]');
    const closeMenuButtons = document.querySelectorAll('[data-imm-menu-close]');

    const closeMenu = () => {
      if (!mobileMenu) return;
      mobileMenu.classList.remove('is-open');
      mobileMenu.setAttribute('aria-hidden', 'true');
      body.classList.remove('drawer-open');
      openMenu?.setAttribute('aria-expanded', 'false');
    };

    openMenu?.addEventListener('click', () => {
      if (!mobileMenu) return;
      mobileMenu.classList.add('is-open');
      mobileMenu.setAttribute('aria-hidden', 'false');
      body.classList.add('drawer-open');
      openMenu.setAttribute('aria-expanded', 'true');
    });

    closeMenuButtons.forEach((button) => button.addEventListener('click', closeMenu));

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeMenu();
    });

    // Room guide segmented controls.
    document.querySelectorAll('[data-imm-segment-group]').forEach((group) => {
      group.querySelectorAll('[data-imm-segment]').forEach((button) => {
        button.addEventListener('click', () => {
          group.querySelectorAll('[data-imm-segment]').forEach((item) => {
            item.classList.remove('is-active');
            item.setAttribute('aria-pressed', 'false');
          });
          button.classList.add('is-active');
          button.setAttribute('aria-pressed', 'true');
        });
      });
    });

    // Quantity buttons for the main product are native Dawn controls.
    // Keep the sticky bar synchronized with price and selected variant.
    const productRoot = document.querySelector('[data-imm-main-product]');
    const stickyBar = document.querySelector('[data-imm-sticky-buy]');
    const stickyButton = stickyBar?.querySelector('[data-imm-sticky-submit]');
    const stickyPrice = stickyBar?.querySelector('[data-imm-sticky-price]');
    const stickyVariant = stickyBar?.querySelector('[data-imm-sticky-variant]');
    const mainSubmit = productRoot?.querySelector('.product-form__submit');
    const buyAnchor = productRoot?.querySelector('[data-imm-buy-anchor]');
    const sectionId = productRoot?.dataset.sectionId;
    const priceSource = sectionId ? document.getElementById(`price-${sectionId}`) : null;

    const updateStickyPrice = () => {
      if (!stickyPrice || !priceSource) return;
      const priceText =
        priceSource.querySelector('.price-item--sale')?.textContent?.trim() ||
        priceSource.querySelector('.price-item--regular')?.textContent?.trim() ||
        priceSource.textContent?.trim();
      if (priceText) stickyPrice.textContent = priceText.replace(/\s+/g, ' ');
    };

    const syncMainBundleVariant = () => {
      if (!productRoot) return;
      const formVariantInput = productRoot.querySelector(`form[id^="product-form-"] input[name="id"]`);
      const bundleInput = productRoot.querySelector('[data-imm-main-bundle-item]');
      if (!formVariantInput || !bundleInput) return;
      bundleInput.value = formVariantInput.value;
      const activeVariant = window.__immProductVariants?.find?.((variant) => String(variant.id) === String(formVariantInput.value));
      if (activeVariant && bundleInput.dataset) bundleInput.dataset.price = activeVariant.price;
      bundleInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const updateStickyVariant = () => {
      if (!stickyVariant || !productRoot) return;
      const values = [];
      productRoot.querySelectorAll('variant-selects fieldset, variant-selects .product-form__input').forEach((group) => {
        const checked = group.querySelector('input[type="radio"]:checked');
        const selected = group.querySelector('select option:checked');
        const value = checked?.value || selected?.textContent?.trim();
        if (value) values.push(value);
      });
      if (values.length) stickyVariant.textContent = values.join(' · ');
    };

    updateStickyPrice();
    updateStickyVariant();
    syncMainBundleVariant();

    if (priceSource) {
      new MutationObserver(updateStickyPrice).observe(priceSource, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    const variantPicker = productRoot?.querySelector('variant-selects');
    if (variantPicker) {
      variantPicker.addEventListener('change', () => {
        window.setTimeout(() => {
          updateStickyPrice();
          updateStickyVariant();
          syncMainBundleVariant();
        }, 80);
      });
      new MutationObserver(updateStickyVariant).observe(variantPicker, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['checked', 'selected'],
      });
    }

    stickyButton?.addEventListener('click', () => {
      const currentSubmit = productRoot?.querySelector('.product-form__submit');
      if (currentSubmit && !currentSubmit.disabled) currentSubmit.click();
    });

    if (stickyBar && buyAnchor) {
      const observer = new IntersectionObserver(
        ([entry]) => stickyBar.classList.toggle('is-visible', !entry.isIntersecting),
        { threshold: 0.15 },
      );
      observer.observe(buyAnchor);
    }



    // Keep the native Dawn media track aligned after modal close and viewport changes.
    // The gallery no longer relies on opacity or visibility classes to display media.
    const alignProductGallery = (gallery) => {
      if (!gallery) return;

      const track = gallery.querySelector('.product__media-list');
      const items = Array.from(gallery.querySelectorAll('.product__media-item[data-media-id]'));
      if (!track || !items.length) return;

      const currentThumbnailItem = gallery
        .querySelector('.thumbnail[aria-current="true"]')
        ?.closest('[data-target]');

      const requestedId = currentThumbnailItem?.dataset.target;
      const activeItem =
        items.find((item) => requestedId && item.dataset.mediaId === requestedId) ||
        items.find((item) => item.classList.contains('is-active')) ||
        items[0];

      items.forEach((item) => item.classList.toggle('is-active', item === activeItem));

      const matchingThumbnailItem = gallery.querySelector(
        `[data-target="${activeItem.dataset.mediaId}"]`,
      );

      if (matchingThumbnailItem) {
        gallery.querySelectorAll('.thumbnail').forEach((thumbnail) => {
          thumbnail.removeAttribute('aria-current');
        });
        matchingThumbnailItem.querySelector('.thumbnail')?.setAttribute('aria-current', 'true');
      }

      const align = () => {
        track.scrollTo({ left: activeItem.offsetLeft, top: 0, behavior: 'auto' });
      };

      window.requestAnimationFrame(() => window.requestAnimationFrame(align));
    };

    const alignAllProductGalleries = () => {
      document.querySelectorAll('.imm-product-gallery media-gallery').forEach(alignProductGallery);
    };

    let galleryAlignTimer = 0;
    const scheduleGalleryAlignment = () => {
      window.clearTimeout(galleryAlignTimer);
      galleryAlignTimer = window.setTimeout(alignAllProductGalleries, 40);
    };

    alignAllProductGalleries();
    window.addEventListener('resize', scheduleGalleryAlignment, { passive: true });
    window.visualViewport?.addEventListener('resize', scheduleGalleryAlignment, { passive: true });
    document.body.addEventListener('modalClosed', scheduleGalleryAlignment);
    document.addEventListener('shopify:section:load', scheduleGalleryAlignment);
    document.addEventListener('shopify:section:reorder', scheduleGalleryAlignment);

    document.querySelectorAll('.imm-product-gallery media-gallery').forEach((gallery) => {
      gallery.querySelectorAll('.thumbnail').forEach((thumbnail) => {
        thumbnail.addEventListener('click', () => {
          window.setTimeout(() => alignProductGallery(gallery), 20);
        });
      });
    });

    // Product bundle.
    document.querySelectorAll('[data-imm-bundle]').forEach((bundle) => {
      const inputs = [...bundle.querySelectorAll('[data-imm-bundle-item]')];
      const total = bundle.querySelector('[data-imm-bundle-total]');
      const button = bundle.querySelector('[data-imm-bundle-add]');
      const moneyFormat = bundle.dataset.moneyFormat || '${{amount}}';

      const formatMoney = (cents) => {
        if (window.Shopify?.formatMoney) return window.Shopify.formatMoney(cents, moneyFormat);
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: bundle.dataset.currency || 'USD',
        }).format(cents / 100);
      };

      const updateBundleTotal = () => {
        const cents = inputs
          .filter((input) => input.checked)
          .reduce((sum, input) => sum + Number(input.dataset.price || 0), 0);
        if (total) total.textContent = formatMoney(cents);
        if (button) button.disabled = cents === 0;
      };

      inputs.forEach((input) => input.addEventListener('change', updateBundleTotal));
      updateBundleTotal();

      button?.addEventListener('click', async () => {
        const items = inputs
          .filter((input) => input.checked && input.value)
          .map((input) => ({ id: Number(input.value), quantity: 1 }));

        if (!items.length) return;

        button.disabled = true;
        button.classList.add('loading');

        try {
          const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
          const sections = cart?.getSectionsToRender?.().map((section) => section.id) || ['cart-icon-bubble'];
          const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items,
              sections,
              sections_url: window.location.pathname,
            }),
          });

          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || 'Unable to add the set.');

          if (cart?.renderContents) {
            cart.renderContents(data);
          } else {
            window.location.href = window.routes?.cart_url || '/cart';
          }
        } catch (error) {
          console.error('[ImmHome bundle]', error);
          window.alert(error.message || 'Unable to add the selected products.');
        } finally {
          button.disabled = false;
          button.classList.remove('loading');
        }
      });
    });

    // Theme editor section reloads.
    document.addEventListener('shopify:section:load', () => {
      document.dispatchEvent(new Event('DOMContentLoaded'));
    });
  });
})();
